import {React, useContext} from 'react'
import RoutesContext from '../contexts/RoutesContext'
import BreadcrumbsSection from './BreadcrumbsSection'
import contacts_bg from "./static/img/contacts-bg.jpg"
import footer_icon_black from "./static/img/icons/ico-footer-black1.svg"
import footer_icon_black_2 from "./static/img/icons/ico-footer-black2.svg"
import footer_icon_black_3 from "./static/img/icons/ico-footer-black3.svg"

function ContactsPage(props) {
    let routes_context = useContext(RoutesContext);
  return (
    <main>
        <BreadcrumbsSection routes={routes_context.routes} page_name="Contacts" />

        
        <div className="contacts_title_section">
            <div className="contacts_title_inner_wrapper">
                <h1>Contacts</h1>
            </div>
        </div>

        <div className="contacts_content_section">
            <div className="column_1">
                <img src={contacts_bg} alt="" />
                <div className="column_1_content">
                    <div className="row_1">
                        <img src={footer_icon_black} alt="" />
                        <span>Turkmenistan, Ashgabat city, 1945<br /> street, 98 “Altyn Asyr” Shopping Centre</span>
                    </div>
                    <div className="row_2">
                        <img src={footer_icon_black_2} alt="" />
                        <a href="mailto:infoecosu@gmail.com">infoecosu@gmail.com</a>
                    </div>
                    <div className="row_3">
                        <img src={footer_icon_black_3} alt="" />
                        <a href="tel:+99365650465">+993 (65) 65 04 65</a>
                    </div>
                </div>
            </div>
            <div className="column_2">
                <iframe title='google_map_iframe' src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d3744.3716797742886!2d58.38406518854167!3d37.89236458261141!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2s!4v1674388514858!5m2!1sen!2s" width="100%" height="100%" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>

    </main>
  )
}

export default ContactsPage